<template>
  <div class="object-page-wrapper">
    <div class="page-content d-flex f-column">
      <div class="page-content__meta d-flex f-between">
        <h1 class="page-title">План этажа</h1>
        <div @click="closeFloorPlan()" class="go-back-icon">
          <svg class="d-block ml-auto" xmlns="http://www.w3.org/2000/svg" width="17.999" height="18"
            viewBox="0 0 17.999 18">
            <path id="Union_9" data-name="Union 9"
              d="M-10501-7368.2l-7.2,7.2-1.8-1.8,7.2-7.2-7.2-7.2,1.8-1.8,7.2,7.2,7.2-7.2,1.8,1.8-7.2,7.2,7.2,7.2-1.8,1.8Z"
              transform="translate(10510 7379)" fill="#fefefc" />
          </svg>
        </div>
      </div>

      <div class="floor-plan-wrap f-full d-flex f-column p-relative">
        <div class="floor-plan__items d-flex">
          <div class="flool-plan-left d-flex f-column">
            <span>ЭТАЖ</span>
            <div class="floor-counter p-relative">
              <div class="floor-shadow top-shadow"></div>
              <div class="counter-box" ref="scrollParent">
                <div class="counter-inner">
                  <div class="floor-counter__items" v-for="(item, index) in floors" :key="index"
                    :class="{ 'active': floor == item.val }" @click="changePlan(item.val)">{{ item.text }}</div>
                </div>
              </div>
              <div class="floor-shadow bottom-shadow"></div>
            </div>
          </div>
          <div class="flool-plan-middle">
            <div class="h-100 p-relative">
              <img :src="activeObject.image" alt="Floor Image" ref="zoomImage" class="d-block" />
              <div class="floor-plan-svg p-absolute w-100" style="top: 0" v-html="activeObject.svg"></div>
            </div>
          </div>
          <!-- <div class="flool-plan-right d-flex f-column text-right">
            <span>КОРПУС</span>
            <div class="floor-corps d-flex f-column f-full">
              <div class="floor-corps__items">A</div>
              <div class="floor-corps__items active">B</div>
              <div class="floor-corps__items">C</div>
            </div>
          </div> -->
        </div>
        <!-- <div class="floor-plan__control d-flex f-wrap">
          <div class="floor-plan__control-items items-free d-flex align-center">
            <div class="p-relative mr-3"></div>
            <span>Свободно</span>
          </div>
          <div class="floor-plan__control-items items-sell d-flex align-center">
            <div class="p-relative mr-3"></div>
            <span>Продано</span>
          </div>
          <div class="floor-plan__control-items items-booked d-flex align-center">
            <div class="p-relative mr-3"></div>
            <span>Забронировано</span>
          </div>
        </div> -->
        <div class="floor-plan__meta d-flex align-center">
          <div class="mobile-floor-plan-select">
            <span class="d-block text-white mb-2">ЭТАЖ</span>
            <select v-model="floor" @change="changePlan(floor)">
              <option :value="1">01</option>
              <option :value="2">02</option>
              <option :value="3">03</option>
              <option :value="4">04</option>
              <option :value="5">05</option>
              <option :value="6">06</option>
              <option :value="7">07</option>
              <option :value="8">08</option>
            </select>
          </div>
          <div class="floor-plan__zoom ml-auto pointer p-relative" ref="zoom">
            <p>Увеличить планировку</p>
          </div>
        </div>
      </div>
    </div>
    <BottomNavigation />
  </div>
</template>

<script>
import BottomNavigation from "./components/BottomNavigation";
import { fullScreen, elementScroll } from "@/utils";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      activeObject: {},
      porch: null,
      floor: null,
      plans: [],
      floors: [
        {
          val: 1,
          text: "01"
        },
        {
          val: 2,
          text: "02"
        },
        {
          val: 3,
          text: "03"
        },
        {
          val: 4,
          text: "04"
        },
        {
          val: 5,
          text: "05"
        },
        {
          val: 6,
          text: "06"
        },
        {
          val: 7,
          text: "07"
        },
        {
          val: 8,
          text: "08"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      list: "projects/projects",
    })
  },
  created() {
    this.porch = this.$route ? +this.$route.params.porche : null;
    this.floor = this.$route ? +this.$route.params.floor : null;
    const project_id = this.$route ? +this.$route.params.project : null;
    const project = this.list.find(function (item) {
      return project_id == item.id;
    });

    
    const house_id = this.$route ? parseInt(this.$route.params.house) : null;
    const house = project.houses.find(item => {
      return house_id == item.id;
    });
    this.plans = house.house_plans;
    // console.log(house);
    
    this.setPlan();
  },
  mounted() {
    const { zoom, zoomImage, scrollParent } = this.$refs;
    fullScreen(zoom, zoomImage);
    // elementScroll(scrollParent);
  },
  components: {
    BottomNavigation
  },
  methods: {
    setPlan() {
      this.activeObject = this.plans.find(item => {
        return this.floor == item.floor && this.porch == item.porch;
      });

    },
    changePlan(n) {
      this.floor = n;
      this.setPlan();
      this.$router.push({
        name: "FloorPlan",
        params: {
          project: this.$route.params.project,
          house: this.$route.params.house,
          porche: this.porch,
          floor: this.floor
        }
      });
    },
    closeFloorPlan() {
      this.$router.push({
        name: 'ApartmentSelection',
        params: {
          project: this.$route.params.project,
          house: this.$route.params.house
        }
      });
    }
  }
};
</script>
